export const AnswerType = [
  { id: 1, value: 1, text: "Answers" },
  { id: 2, value: 2, text: "Conditions" },
];

export const getRole = [
  {
    id: 1,
    icon: "fh-icon fh-icon-short-paragraph",
    label: "Short Answer",
    disabled: false,
  },
  {
    id: 2,
    icon: "fh-icon fh-icon-long-paragraph",
    label: "Paragraph",
    disabled: false,
  },
  { id: 3, icon: "fh-icon fh-icon-circle", label: "NPS", disabled: false },
  {
    id: 4,
    icon: "fh-icon fh-icon-radio-button",
    label: "Single Selection",
    disabled: false,
  },
  {
    id: 5,
    icon: "fh-icon fh-icon-checkbox",
    label: "Multiple Selection",
    disabled: false,
  },
  {
    id: 6,
    icon: "fh-icon fh-icon-email-setting",
    label: "Email",
    disabled: true,
  },
  { id: 7, icon: "fh-icon fh-icon-number", label: "Number", disabled: true },
  {
    id: 8,
    icon: "fh-icon fh-icon-circle-star",
    label: "Rating",
    disabled: false,
  },
];

export const questionsTypeList = [
  {
    id: 1,
    icon: "fh-icon fh-icon-short-paragraph",
    label: "Short Answer",
    disabled: false,
  },
  {
    id: 2,
    icon: "fh-icon fh-icon-long-paragraph",
    label: "Paragraph",
    disabled: false,
  },
  { id: 3, icon: "fh-icon fh-icon-circle", label: "NPS", disabled: false },
  {
    id: 4,
    icon: "fh-icon fh-icon-radio-button",
    label: "Single Selection",
    disabled: false,
  },
  {
    id: 5,
    icon: "fh-icon fh-icon-checkbox",
    label: "Multiple Selection",
    disabled: false,
  },
  {
    id: 6,
    icon: "fh-icon fh-icon-email-setting",
    label: "Email",
    disabled: true,
  },
  { id: 7, icon: "fh-icon fh-icon-number", label: "Number", disabled: true },
  {
    id: 8,
    icon: "fh-icon fh-icon-circle-star",
    label: "Rating",
    disabled: false,
  },
];

export const actionsBtn = [
  { id: 1, icon: "fh-icon fh-icon-edit", btnName: "edit" },
  { id: 2, icon: "fh-icon fh-icon-delete", btnName: "delete" },
];

export const optionActionButton = [
  { id: 1, icon: "fh-icon fh-icon-circle-plus", btnName: "add" },
  { id: 2, icon: "fh-icon fh-icon-delete", btnName: "delete" },
];

export const RatingFormat = [
  { id: 1, icon: "fh-icon fh-icon-star", label: "Star" },
  { id: 2, icon: "fh-icon fh-icon-happy-outline", label: "Smiley" },
  { id: 3, icon: "fh-icon fh-icon-circle", label: "Radio Button" },
];

export const NpsStyleFormat = [
  { id: 1, icon: "fh-icon fh-icon-circle", label: "Radio Button" },
  { id: 2, icon: "fh-icon fh-icon-happy-outline", label: "Smiley" },
];

export const Count = [
  { id: 1, label: "2" },
  { id: 1, label: "3" },
  { id: 2, label: "4" },
  { id: 3, label: "5" },
];

export const colorArray2 = ["#D84945", "#166A59"];
export const colorArray3 = ["#D84945", "#D89E45", "#166A59"];
export const colorArray4 = ["#D84945", "#D86445", "#D89E45", "#166A59"];
export const colorArray5 = [
  "#D84945",
  "#D86445",
  "#D89E45",
  "#45D853",
  "#166A59",
];

export const smileyArray2 = ["fh-icon-angry-filled", "fh-icon-happy-filled"];
export const smileyArray3 = [
  "fh-icon-angry-filled",
  "fh-icon-neutral-filled",
  "fh-icon-happy-filled",
];
export const smileyArrayOutline2 = [
  "fh-icon-angry-outline",
  "fh-icon-happy-outline",
];
export const smileyArrayOutline3 = [
  "fh-icon-angry-outline",
  "fh-icon-neutral-outline",
  "fh-icon-happy-outline",
];
export const smileyArray4 = [
  "fh-icon-angry-filled",
  "fh-icon-sad-filled",
  "fh-icon-neutral-filled",
  "fh-icon-happy-filled",
];
export const smileyArrayOutline4 = [
  "fh-icon-angry-outline",
  "fh-icon-sad-outline",
  "fh-icon-neutral-outline",
  "fh-icon-happy-outline",
];

export const smileyArray5 = [
  "fh-icon-angry-filled",
  "fh-icon-sad-filled",
  "fh-icon-neutral-filled",
  "fh-icon-smile-filled",
  "fh-icon-happy-filled",
];
export const smileyArrayOutline5 = [
  "fh-icon-angry-outline",
  "fh-icon-sad-outline",
  "fh-icon-neutral-outline",
  "fh-icon-smile-outline",
  "fh-icon-happy-outline",
];

export const ansTypeOptions = [
  { id: 1, label: "Yes", value: "=" },
  { id: 2, label: "No", value: "!" },
];
export const conditionOptions = ["And", "Or"];
export const comparisonOptions = [
  { id: 1, label: "Greater than(>)", value: ">" },
  { id: 2, label: "Less than(<)", value: "<" },
  { id: 3, label: "Equal to", value: "=" },
];

export const npsRatingOptions = [
  { id: 1, label: "1", value: "1" },
  { id: 2, label: "2", value: "2" },
  { id: 3, label: "3", value: "3" },
  { id: 4, label: "4", value: "4" },
  { id: 5, label: "5", value: "5" },
  { id: 6, label: "6", value: "6" },
  { id: 7, label: "7", value: "7" },
  { id: 8, label: "8", value: "8" },
  { id: 9, label: "9", value: "9" },
  { id: 10, label: "10", value: "10" },
];

export const singleMultipleOptions = [
  { id: 1, label: "is", value: "=" },
  { id: 2, label: "is not", value: "!=" },
];
